{
  "unknown": "Candidat inconnu",
  "phonePlaceholder": "+",
  "selectedCandidates": {
    "meta": {
      "title": "Candidats sélectionnés",
      "description": "Sélection des candidats retenus"
    },
    "title": "Candidats sélectionnés",
    "breadcrumbTail": "Candidats sélectionnés",
    "allWithCount": "Tous ({{count}})",
    "emptyListTitle": "La liste des candidats est vide",
    "emptyListHint": "Aucun candidat n’a été trouvé pour la sélection.",
    "recommendedTitle": "Candidats recommandés",
    "recommendedCount_one": "candidat",
    "recommendedCount_other": "candidats",
    "pick": "Voir les candidats",
    "pickDescription": "Cliquez sur « Sélectionner » pour choisir de nouveaux candidats",
    "loadingRecommended": "Chargement des candidats recommandés",
    "loadingSelected": "Chargement des candidats sélectionnés",
    "close": "Fermer",
    "detailPrev": "Précédent",
    "detailNext": "Suivant",
    "table": {
      "id": "ID",
      "fullName": "Nom et prénom"
    },
    "drawerTitle": "Sélection de candidats",
    "vacancy": "Poste :",
    "vacantPlaces": "Postes vacants :",
    "noRelevantTitle": "Aucun candidat pertinent trouvé",
    "noRelevantHint": "Pour sélectionner de nouveaux candidats, cliquez sur « Sélectionner ».",
    "noRelevantHintTryLater": "Pour le moment, aucun candidat pertinent n’a été trouvé. Réessayez plus tard.",
    "candidatePosition": "Candidat : ",
    "positionFraction": "{{current}} / {{total}}",
    "age": "Âge :",
    "matchAssessment": "Compatibilité avec le poste",
    "matchStatusFits": "Convient",
    "matchStatusMostlyFits": "Bon potentiel",
    "matchStatusPartial": "Faible potentiel",
    "matchStatusNotFits": "Ne convient pas",
    "matchReasonShow": "Afficher",
    "matchReasonHide": "Masquer",
    "readyToWork": "Disponible pour commencer",
    "summary": "Expérience et compétences",
    "incomeLevel": "Niveau de rémunération",
    "phone": "Numéro de téléphone",
    "phoneTooltip": "Le numéro sera disponible après la sélection du candidat",
    "reject": "Refuser",
    "select": "Choisir",
    "decisionPending": "Décision non prise",
    "decisionSelected": "Candidat choisi",
    "decisionRejected": "Candidat refusé",
    "openCandidatesList": "Afficher la liste des candidats",
    "backToPick": "Retour",
    "candidatesCount": "Candidats : {{count}}",
    "skillsFitLine1": "Correspondance",
    "skillsFitLine2": "aux compétences :",
    "rejectModal": {
      "title": "Refus de la candidature",
      "confirmBeforeName": "Voulez-vous vraiment refuser la candidature de ",
      "confirmAfterName": " ? Ce candidat ne sera plus proposé pour ce poste",
      "noRejectionReasons": "Aucun motif de refus n’est disponible. Contactez un administrateur ou réessayez plus tard.",
      "reasonLabel": "Motif du refus",
      "customDetailLabel": "Précision du motif",
      "customDetailDescription": "Décrivez le motif. Maximum {{max}} caractères",
      "commentPlaceholder": "Commentaire",
      "back": "Retour",
      "confirmReject": "Refuser",
      "validationCustomRequired": "Indiquez une précision pour le motif",
      "maxLength": "Au plus {{max}} caractères",
      "customReasonPrefix": "Autre : ",
      "reasons": {
        "requirements": "Le candidat ne correspond pas aux exigences",
        "experience": "Expérience insuffisante",
        "custom": "Autre"
      }
    }
  },
  "status": {
    "proposed": "Proposé",
    "accepted": "Accepté",
    "rejected": "Rejeté"
  },
  "match": {
    "skills": "Correspond aux compétences à {{percent}}%"
  }
}
